import VenueDetail from '../../Components/Venue/Detail';

const PageVenueDetail = () => {
  return <VenueDetail />;
}

export default PageVenueDetail;